export default __webpack_public_path__ + "static/media/wallet-connect-text.78166b41.svg";